import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Textarea from '~/components/Form/Textarea';
import Load from '~/components/Load';

import { Container } from './styles';

export default function TentativaEdit({ match }) {
  const inputRef = useRef(null);
  const [dado, setDado] = useState([]);
  const [tipoSelect, setTipoSelect] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visibleAssunto, setVisibleAssunto] = useState(false);

  useEffect(() => {
    async function getDados() {
      setLoading(true);
      const { idCad, idTent } = match.params;
      const response = await api.get(`/cadencia/${idCad}/tentativa/${idTent}`);

      const tiposTemplate = [
        {
          label: 'Telefone',
          value: 'Telefone',
        },
        {
          label: 'Whatsapp',
          value: 'Whatsapp',
        },
        {
          label: 'E-mail',
          value: 'E-mail',
        },
      ];

      // Selecionando o tipo
      const dataTipo = tiposTemplate.filter(tipo => {
        return tipo.value === response.data.tipo;
      });

      if (response.data.tipo === 'E-mail') {
        setVisibleAssunto(true);
      }
      setTipos(tiposTemplate);
      setTipoSelect(dataTipo[0]);
      setDado(response.data);
      setLoading(false);
    }
    getDados();
  }, [match, match.params]);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      const { idCad, idTent } = match.params;
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        tentativa: Yup.string().required('Preencha o campo tentativa'),
        tipo: Yup.string('Selecione um tipo de tentativa').required(
          'Selecione um tipo de tentativa'
        ),
        instrucao: Yup.string().required('Preencha o campo instrução'),
        tempo: Yup.string().required('Preencha o campo tempo'),
        assunto: visibleAssunto
          ? Yup.string().required('Preencha o campo assunto')
          : null,
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/cadencia/${idCad}/tentativa/${idTent}`, {
        tentativa: data.tentativa,
        tipo: data.tipo,
        instrucao: data.instrucao,
        tempo: data.tempo,
        assunto: visibleAssunto ? data.assunto : null,
      });

      toast.success('Tentativa editado com sucesso');
      history.push(`/cadencia-edit/${idCad}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar tentativa, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  function handlerChange(e) {
    setTipoSelect(e);
    if (e.value === 'E-mail') {
      setVisibleAssunto(true);
    } else {
      setVisibleAssunto(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Tentativa</h4>
      <Card>
        <Form
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
          initialData={dado}
        >
          <Input
            icon="MdRepeat"
            label="Tentativa"
            name="tentativa"
            type="number"
          />
          <Select
            name="tipo"
            labelSelect="Tipo de tentativa"
            options={tipos}
            onChange={e => handlerChange(e)}
            defaultValue={tipoSelect}
          />
          {visibleAssunto && (
            <Input icon="MdMail" label="Assunto" name="assunto" type="text" />
          )}
          <Textarea label="Instrução" name="instrucao" type="text" />
          <Input icon="MdAlarm" label="Tempo" name="tempo" type="number" />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

TentativaEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idCad: PropTypes.string,
      idTent: PropTypes.string,
    }),
  }).isRequired,
};
